import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LoginForm from "../../../molecules/containers/LoginForm";
import { userIsNotAuthenticated } from "../../../auth";
import logo from "../../../assets/logo.png";
import { toggleLostSignInLink, isLostPassOpen } from "../../../store/common";
import { getTranslate } from "react-localize-redux";
import ErrorModal from "../../../containers/ErrorModal";

class LoginContainer extends Component {
  componentDidMount() {
    localStorage.clear();
  }
  render() {
    const { isLostPassOpen, toggleLostSignInLink, translate } = this.props;
    return (
      <div className="page__overlay">
        <div className="login__account">
          <div className="login__box">
            <div className="login__header">
              <img src={logo} /> |{" "}
              {translate("routes.login.loginContainer.login_title")}
            </div>
            <div className="login__account__form">
              <div className="form-title">
                {!isLostPassOpen
                  ? translate("routes.login.loginContainer.please_login_title")
                  : translate(
                      "routes.login.loginContainer.reset_password_title"
                    )}
              </div>
              <LoginForm section={"login"} />
            </div>
            <span
              className="reset__pass"
              onClick={() => toggleLostSignInLink()}
            >
              {isLostPassOpen
                ? translate("routes.login.loginContainer.signin_link")
                : translate("routes.login.loginContainer.lost_password_link")}
            </span>
          </div>
        </div>
        <ErrorModal />
      </div>
    );
  }
}

LoginContainer.propTypes = {
  isLostPassOpen: PropTypes.bool,
  toggleLostSignInLink: PropTypes.func,
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale),
  isLostPassOpen: isLostPassOpen(common.lostPassOpen)
});

const mapDispatchToProps = dispatch => ({
  toggleLostSignInLink: () => dispatch(toggleLostSignInLink())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userIsNotAuthenticated(LoginContainer));



// WEBPACK FOOTER //
// ./src/routes/Login/containers/LoginContainer.js